import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import { 
    TDef, 
    Container, 
    WrapperCell,
    StudentNameCell, StudentAttendanceCell, 
    StudentIdCell } from "./styles";

const ListItem = ({
    id, 
    name, 
    disabled,
    attendance, 
    positionRow, 
    changeAttendance, 
    errorSaveAttendance,
    onlyOne, 
    isPinned 
}) => {
    const getClassName = (positionCell = 1) => {
        const classList = [];
        if (positionRow !== 0) 
            classList.push(positionRow === 1 
                ? "first-row"
                : "last-row");
        if (positionCell !== 0)
            classList.push(positionCell === 1
                ? "first-cell"
                : "last-cell");
        isPinned &&  classList.push("is-pinned");
        onlyOne && classList.push("only-one");
        return classList.join(" ");
    }
    const 
        studentIdClassName = getClassName(1),
        studentNameClassName = getClassName(0),
        studentAttendanceClassName = getClassName(-1);
    return (
        <Container>
            <TDef>
                <StudentIdCell 
                    className={studentIdClassName}>
                    <WrapperCell className={studentIdClassName}>
                        <span>{id}</span>
                    </WrapperCell>
                </StudentIdCell>
            </TDef>
            <TDef>
                <StudentNameCell 
                    className={studentNameClassName}>
                    <WrapperCell className={studentNameClassName}>
                        <span>{name}</span>
                    </WrapperCell>
                </StudentNameCell>
            </TDef>
            <TDef>
                <StudentAttendanceCell 
                    className={studentAttendanceClassName}>
                    <WrapperCell 
                        className={studentAttendanceClassName}>
                        <CustomCheckbox 
                            disabled={disabled}
                            onChange={() => changeAttendance(id)} 
                            checked={attendance}
                            error={errorSaveAttendance}/>
                    </WrapperCell>
                </StudentAttendanceCell>
            </TDef>
        </Container>
    );
}

export default ListItem;